import { defineStore } from 'pinia';
import { ref } from 'vue';
import useStore from '@/store';
import { Slide } from '@/entities';

export default defineStore('slide', () => {
  const rootStore = useStore();
  const slides = ref<Slide[]>([]);
  const isLoading = ref(false);

  return {
    slides,
    isLoading,

    async init() {
      isLoading.value = true;
      slides.value = (await this.getSlides()) || [];
      isLoading.value = false;
    },
    async getSlides() {
      const cmsLocale = rootStore.user.cmsLocale;
      const accountType = rootStore.user.user?.accountType;
      const account = rootStore.user.user?.account;

      return rootStore.apiService.slide.fetchSlides(cmsLocale, accountType, account).then((data) => {
        if (data) {
          return data.map((slideData) => new Slide(slideData));
        }
      });
    }
  };
});
